(() => {
  const root = document.body;
  const messages = JSON.parse(document.getElementById('pxs-messages')?.textContent || '{}');
  let scheduled = false;
  const observedModals = new WeakSet();
  let primaryVisible = true;
  const nativeButton = form => form?.querySelector('.es-popup-button');
  const modalOpen = () => {
    const form = document.getElementById('es-form');
    return Boolean(form && form.getBoundingClientRect().height && getComputedStyle(form).visibility !== 'hidden');
  };
  const sync = () => {
    scheduled = false;
    const modal = document.getElementById('es-form-container');
    if (modal && !observedModals.has(modal)) { observedModals.add(modal); new MutationObserver(schedule).observe(modal,{attributes:true,attributeFilter:['style','class','hidden'],subtree:true}); }

    document.querySelectorAll('[data-pxs-product-form], [data-pxs-cart-form]').forEach(form => {
      const ready = Boolean(nativeButton(form));
      form.classList.toggle('pxs-easysell-ready', ready);
    });
    const sticky = document.querySelector('[data-pxs-sticky]');
    if (sticky) {
      const form = sticky.closest('form');
      const primary = document.querySelector('[data-pxs-primary-order]');
      const show = Boolean(nativeButton(form)) && !primaryVisible && primary?.getBoundingClientRect().bottom < 0 && !modalOpen();
      sticky.hidden = !show;
      root.classList.toggle('pxs-has-sticky', show);
    }
    root.classList.toggle('pxs-order-open', modalOpen());
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(sync); } };
  new MutationObserver(schedule).observe(root, {childList:true,subtree:true});
  const primary = document.querySelector('[data-pxs-primary-order]');
  if (primary) new IntersectionObserver(entries => { primaryVisible = entries[0].isIntersecting; schedule(); }, {threshold:0}).observe(primary);
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-pxs-quantity]');
    if (quantityButton) {
      const input = quantityButton.closest('.pxs-quantity').querySelector('input');
      const min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(max, Math.max(min, Number(input.value || min) + Number(quantityButton.dataset.pxsQuantity))));
      input.dispatchEvent(new Event('input', {bubbles:true}));
      input.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    const photo = event.target.closest('[data-pxs-photo]');
    if (photo) {
      const gallery = photo.closest('.pxs-gallery'), image = gallery.querySelector('.pxs-main-image');
      image.src = photo.dataset.pxsPhoto;
      image.srcset = photo.dataset.pxsSrcset;
      gallery.querySelectorAll('[data-pxs-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === photo)));
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-pxs-cart-form] input[name="updates[]"]')) event.target.form.dataset.pxsCartDirty = 'true';
    if (event.target.matches('[data-pxs-sort]')) event.target.form.requestSubmit();
    if (event.target.matches('[data-pxs-variant]')) {
      const form = event.target.form, option = event.target.selectedOptions[0];
      const component = form.closest('[data-pxs-card], [data-pxs-product]');
      component.querySelectorAll('[data-pxs-price], .pxs-card-price').forEach(el => { el.textContent = option.dataset.price || ''; });
      const quantity = form.querySelector('input[name="quantity"]');
      if (quantity && quantity.type !== 'hidden') {
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        if (quantity.max && Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
      }
      if (component.matches('[data-pxs-product]') && option.value) {
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      }
    }
  });
  document.addEventListener('submit', event => {
    const form=event.target;
    if (!form.matches('.pxs-catalogue-controls, .pxs-search-panel')) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const url=new URL(form.action,location.origin); url.search='';
    for (const [key,value] of new FormData(form)) if(value !== '') url.searchParams.append(key,value);
    location.assign(url.href);
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-pxs-product-form]');
    if (!form || event.defaultPrevented) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    form.dataset.busy = 'true';
    const button = event.submitter || form.querySelector('[name="add"]');
    const status = form.querySelector('[data-pxs-form-message]') || form.closest('[data-pxs-card]')?.querySelector('[data-pxs-form-message]');
    if (button) button.disabled = true;
    try {
      const path = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${path}cart/add.js`, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || messages.error);
      if (status) {
        status.replaceChildren(document.createTextNode(`${messages.added} `));
        const link = document.createElement('a'); link.href = `${path}cart`; link.textContent = messages.view_cart; status.append(link);
      }
      const cartResponse = await fetch(`${path}cart.js`, {headers:{Accept:'application/json'}});
      if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = !cart.item_count; }); }
    } catch (error) { if (status) status.textContent = error.message || messages.error; }
    finally { form.dataset.busy = 'false'; if (button) button.disabled = false; }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.pxs-header details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
  });
  const visibleBuyControls=new Set();
  const buyObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting) visibleBuyControls.add(entry.target);else visibleBuyControls.delete(entry.target);});root.classList.toggle('pxs-buy-visible',visibleBuyControls.size>0);},{threshold:0});
  document.querySelectorAll('main [data-pxs-order], main [name="add"], main [name="checkout"]').forEach(button=>buyObserver.observe(button));
  document.addEventListener('pxs:products:loaded', event => { event.target.querySelectorAll('[data-pxs-order], [name="add"]').forEach(button => buyObserver.observe(button)); });
  document.addEventListener('click',event=>{if(event.target.closest('#es-form-container, .es-popup-button')) schedule();});
  window.addEventListener('scroll',schedule,{passive:true});
  sync();
})();

// Diagnostics use the browser Performance APIs only in explicit QA mode.
if (new URLSearchParams(location.search).has('pxs_qa')) {
 const output=document.createElement('output');output.id='pxs-performance';output.style.cssText='position:fixed;bottom:60px;left:12px;z-index:999999;background:#fff;color:#111;padding:12px;border:1px solid #ccc;max-width:600px;font:12px monospace';document.body.append(output);
 const result={lcp_ms:0,cls:0};const publish=()=>{const n=performance.getEntriesByType('navigation')[0];output.textContent=JSON.stringify({...result,width:document.documentElement.clientWidth,scrollWidth:document.documentElement.scrollWidth,ttfb_ms:Math.round(n.responseStart),dom_ready_ms:Math.round(n.domContentLoadedEventEnd),load_ms:Math.round(n.loadEventEnd)});};
 try {new PerformanceObserver(list=>{for(const entry of list.getEntries()) result.lcp_ms=Math.round(entry.startTime);publish();}).observe({type:'largest-contentful-paint',buffered:true});
 new PerformanceObserver(list=>{for(const entry of list.getEntries()) if(!entry.hadRecentInput) result.cls=Math.round((result.cls+entry.value)*10000)/10000;publish();}).observe({type:'layout-shift',buffered:true});} catch {}
 window.addEventListener('load',()=>setTimeout(publish,0));window.addEventListener('resize',publish);output.addEventListener('click',publish);
}

